import { Pipe, PipeTransform } from '@angular/core';
import { normalCase } from '@nk/utils-lib';

@Pipe({
  name: 'normalCase',
})
export class NormalCasePipe implements PipeTransform {
  public transform(value: string): string {
    if (value) {
      return normalCase(value);
    }
    return value;
  }
}
